import { render } from "./CategoryBar.vue?vue&type=template&id=6d82d63a"
import script from "./CategoryBar.vue?vue&type=script&lang=js"
export * from "./CategoryBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__